module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('error-dialog-base', {
    ref: "base"
  }, [_c('div', {
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("データ接続中に"), _c('wbr'), _vm._v("予期せぬエラーが"), _c('wbr'), _vm._v("発生しました")]), _vm._v(" "), _c("template", {
    tag: "div",
    attrs: {
      "slot": "message"
    },
    slot: "message"
  }, [_vm._v("画面を再度読み込んで頂き、再度お試しください。"), _c('br'), _vm._v("何度かこのエラーが続く場合は以下をご確認ください。")]), _vm._v(" "), _c('section', {
    staticClass: "my-section pb10"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("ダウンロードデータのクリアをお試しください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("\n        以下のボタンを押してデータのクリアをお試しください。※データの再ダウンロードが必要になります\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "mt10 tac"
  }, [_c('dn-btn', {
    attrs: {
      "sm": "",
      "accent": ""
    },
    on: {
      "click": _vm.clearData
    }
  }, [_vm._v("データを削除する")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("お使いのブラウザをご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("以下のブラウザでこのページを表示可能です。")]), _vm._v(" "), _c('my-compatibleTable')], 1), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("プライベートブラウズモードで表示されていないかご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("プライベートブラウズ状態でページが表示されている場合データの保存ができません。"), _c('br'), _vm._v("通常の状態でページを開き直してお試しください。")])]), _vm._v(" "), _c('section', {
    staticClass: "my-section"
  }, [_c('h3', {
    staticClass: "mdTtl03"
  }, [_vm._v("Cookieやストレージ機能が無効設定されていないかご確認ください")]), _vm._v(" "), _c('p', {
    staticClass: "my-small-guide"
  }, [_vm._v("ブラウザのストレージ設定が無効化されている場合データの保存ができません。"), _c('br'), _vm._v("お使いのブラウザごとに以下の手順をお試しください。")]), _vm._v(" "), _c('my-howtocookie')], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d071f85","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/manager/DbManager/dialogs/DialogExceptionError.vue
// module id = 461
// module chunks = 1